const nb = {

    dateSelector: "#dispatch_date",
    // giftCardTextSelector: "#handwritten_text",
    giftCardTextSelector: "#CartNote",
    giftCardCheckSelector: "#handwritten-gift-cards",
    formSelector: "#CartPageForm",
    addNoteButton: ".handwritten-giftcards .add-note",
    textfieldWrapper: ".handwrite-option-box",

    localStorageKey: "nbhandwritetext",


    initCart: () => {

        if (!theme.settings.isCartTemplate) {
            return;
        }

        const submit = document.querySelector(nb.formSelector + ' button[type=submit]');
        const form = document.querySelector(nb.formSelector);
        const addNoteButton = document.querySelector(nb.addNoteButton);
        const checkbox = document.querySelector(nb.giftCardCheckSelector);
        //const textfieldWrapper = document.querySelector(nb.textfieldWrapper);

        const textArea = document.querySelector(nb.giftCardTextSelector);


        /*if (checkbox.checked) {
            textfieldWrapper.classList.add("show");
        } else {
            textfieldWrapper.classList.remove("show");
        }*/

        // Set Text if it was defined earlier

        const text = localStorage.getItem(nb.localStorageKey);
        if (text) {
            textArea.value = text;
        }

        //Theme loaded handler

        // On submit button click (on Checkout)
        submit.addEventListener("click", (e) => {
            if (document.querySelector(nb.dateSelector).value == '') {
                alert("Please pick a Dispatch Date.")
                e.preventDefault();
            }
        });

        // On form submit
        form.addEventListener("submit", (e) => {
            if (document.querySelector(nb.dateSelector).value == '') {
                alert("Please pick a Dispatch Date.")
                e.preventDefault();
            }

            // Remove stored text
            localStorage.removeItem(nb.localStorageKey)
        });

        // On text update
        textArea.addEventListener("change", e => {
            localStorage.setItem(nb.localStorageKey, e.target.value);
        });

        nb.datePickerInit();
        nb.cartOptionsInit();

    },

    cartOptionsInit: () => {

        const json = JSON.parse(document.getElementById('handwrittenJson').textContent);

        Shopify.Cart = Shopify.Cart || {};
        Shopify.Cart.HandwrittenGiftCards = {};
        Shopify.Cart.HandwrittenGiftCards = () => {
            var gift_message_cb = document.querySelector('input[type=checkbox][name="attributes[Handwritten gift cards]"]');
            gift_message_cb.addEventListener("change", function (evt) {
                var t = evt.target;
                if (t.checked) {
                    Shopify.Cart.HandwrittenGiftCards.set(json.id);
                } else {
                    Shopify.Cart.HandwrittenGiftCards.remove(json.id);
                }
            });
        }

        Shopify.Cart.HandwrittenGiftCards.set = function (id) {

            let config = JSON.parse(
                JSON.stringify({
                    credentials: 'same-origin',
                    method: 'POST',
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'Content-Type': 'application/json;'
                    }
                })
            );

            config.body = JSON.stringify(
                {
                    updates: {[id]: 1},
                    attributes: {'Handwritten gift cards': true}
                });

            return fetch("/cart/update.js", config).then(function (response) {
                if (!response.ok) {
                    throw response;
                }
                location.href = '/cart';
            });
        }

        Shopify.Cart.HandwrittenGiftCards.remove = function (id) {

            let config = JSON.parse(
                JSON.stringify({
                    credentials: 'same-origin',
                    method: 'POST',
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'Content-Type': 'application/json;'
                    }
                })
            );

            localStorage.removeItem(nb.localStorageKey);

            config.body = JSON.stringify(
                {
                    updates: {[id]: 0},
                    attributes: {'Handwritten gift cards': ''}
                });

            return fetch("/cart/update.js", config).then(function (response) {
                if (!response.ok) {
                    throw response;
                }
                location.href = '/cart';
            });
        }

        Shopify.Cart.HandwrittenGiftCards();
    },

    addProductToCartCallback: () => {
        document.addEventListener(
            'ajaxProduct:added',
            function (evt) {

                const addToCartBtn = evt.detail.addToCartBtn;

                let notification = document.createElement('div');
                    notification.classList.add('notification')
                let text = document.createTextNode("Product has been added to the cart.");
                    notification.appendChild(text);
                    addToCartBtn.parentNode.insertBefore(notification, addToCartBtn);

            }.bind(this)
        )
    },

    _saveDisaptchDate: () => {

        const date = document.querySelector("#dispatch_date");
        if (date.value == '' || date.value.trim() == '') {
            return false;
        }

        let config = JSON.parse(
            JSON.stringify({
                credentials: 'same-origin',
                method: 'POST',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                    'Content-Type': 'application/json;'
                }
            })
        );

        config.body = JSON.stringify(
            {
                attributes: {'dispatch_date': date.value}
            });

        return fetch("/cart/update.js", config).then(function (response) {
            if (!response.ok) {
                throw response;
            }
        });
    },

    datePickerInit: () => {

        const form = document.querySelector("#CartPageForm")

        let files = [
            'https://cdn.jsdelivr.net/npm/vanillajs-datepicker@1.3.4/dist/css/datepicker.min.css',
            'https://cdn.jsdelivr.net/npm/vanillajs-datepicker@1.3.4/dist/js/datepicker-full.min.js'
        ];

        let filePromises = files.map(nb.loadScript);
        Promise.all(filePromises).then((response) => {
            const tommorow = new Date();
            tommorow.setUTCHours(0, 0, 0, 0);
            tommorow.setDate(tommorow.getDate() + 1);

            const elem = document.querySelector(nb.dateSelector);
            const datepicker = new Datepicker(elem, {
                daysOfWeekDisabled: [0, 4, 5, 6],
                datesDisabled: ['2024-12-17', '2024-12-18', '2024-12-23', '2024-12-24', '2024-12-25', '2024-12-30', '2024-12-31', '2025-01-01'],
                format: 'yyyy-mm-dd',
                autohide: true,
                minDate: tommorow,
                todayHighlight: true
            });

            //@todo improve by cheking if a current date is newer. If so do to set date from localStorage
            // If we have a date in the local storage update the calendar
            let dispatch_date = localStorage.getItem('dispatch_date');
            if (dispatch_date) {
                datepicker.setDate(dispatch_date);
            }


            // On Change date save date in the local storage
            elem.addEventListener("changeDate", (e) => {
                dispatch_date = localStorage.setItem('dispatch_date', e.detail.date);

                nb._saveDisaptchDate();


            });

            // Remove date from local storage If user went to checkout
            form.addEventListener("submit", () => {
                localStorage.removeItem('dispatch_date');
            })

        }).catch((err) => {
            console.log(err);
        });
    },

    loadScript: (file) => {

        return new Promise((resolve, reject) => {

            let fileType = file.split('.').pop();

            if (fileType == 'js') {

                // Create a <script> tag, set its source
                let scriptTag = document.createElement('script');

                scriptTag.onload = () => {
                    resolve(scriptTag);
                }
                scriptTag.onerror = () => {
                    reject(new Error("Failed to Load: " + file));
                }

                let cacheBuster = '?bust=' + new Date().getTime();
                // Set the type of file and where it can be found
                scriptTag.type = 'text/javascript';
                scriptTag.src = file + cacheBuster;

                // Finally add it to the <head>
                document.getElementsByTagName('head')[0].appendChild(scriptTag);

            } else if (fileType == 'css') {

                // Create a <script> tag, set its source
                let scriptTag = document.createElement('link');

                scriptTag.onload = () => {
                    resolve(scriptTag);
                }
                scriptTag.onerror = () => {
                    reject(new Error("Failed to Load: " + file));
                }

                let cacheBuster = '?bust=' + new Date().getTime();
                // Set the type of file and where it can be found
                scriptTag.type = 'text/css';
                scriptTag.rel = 'stylesheet';
                scriptTag.href = file + cacheBuster;
                scriptTag.media = "all";

                // Finally add it to the <head>
                document.getElementsByTagName('head')[0].appendChild(scriptTag);

            } else {
                throw new Error("Invalid file type")
            }
        });
    },

    /**
     * Loads CSS and JS files
     * @param files
     * @param callback
     */
    loadFiles: (files, callback) => {

        files.forEach((file) => {

            let fileType = file.split('.').pop();

            if (fileType == 'js') {

                // Create a <script> tag, set its source
                let scriptTag = document.createElement('script');
                // And listen to it
                scriptTag.onload = function (loadEvent) {
                    // This function is an event handler of the script tag
                    if (callback) {
                        callback(loadEvent);
                    }
                }

                let cacheBuster = '?bust=' + new Date().getTime();
                // Set the type of file and where it can be found
                scriptTag.type = 'text/javascript';
                scriptTag.src = file + cacheBuster;

                // Finally add it to the <head>
                document.getElementsByTagName('head')[0].appendChild(scriptTag);

            } else if (fileType == 'css') {

                // Create a <script> tag, set its source
                let scriptTag = document.createElement('link');

                scriptTag.onload = function (loadEvent) {
                    // This function is an event handler of the script tag
                    if (callback) {
                        callback(loadEvent);
                    }
                }

                let cacheBuster = '?bust=' + new Date().getTime();
                // Set the type of file and where it can be found
                scriptTag.type = 'text/css';
                scriptTag.rel = 'stylesheet';
                scriptTag.href = file + cacheBuster;
                scriptTag.media = "all";

                // Finally add it to the <head>
                document.getElementsByTagName('head')[0].appendChild(scriptTag);
            } else {
                throw new Error("Invalid file format. JS/CSS supported.");
            }
        });
    }
}
nb.initCart();
nb.addProductToCartCallback();